import { apiUrl } from 'util/apiUrl';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { useAuthenticatedFetch } from 'hooks/util/useAuthenticatedFetch';

export const useCreateAssessmentShareLink = (assessmentId?: string) => {
  const fetch = useAuthenticatedFetch();
  return useMutation(
    (values: { password: string; isSingle: boolean }) =>
      fetch(`${apiUrl}/AssessmentLink`, {
        body: {
          assessmentId,
          password: values.password,
          isSingle: values.isSingle,
        },
        method: 'POST',
      }),
    {
      onError: () => {
        toast.error('Error generating share link.');
      },
    },
  );
};
